var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5636 12.1062L23.8675 15.9319C24.6721 16.6471 25.0744 17.0047 25.2226 17.427C25.3528 17.7978 25.3528 18.2019 25.2226 18.5727C25.0744 18.995 24.6721 19.3526 23.8675 20.0678L19.5636 23.8935C19.1984 24.2181 19.0159 24.3803 18.8608 24.3861C18.7261 24.3912 18.5967 24.3331 18.511 24.2291C18.4123 24.1093 18.4123 23.865 18.4123 23.3765V20.9643C16.313 20.9643 14.0956 21.6385 12.4765 22.8355C11.6336 23.4586 11.2121 23.7702 11.0516 23.7579C10.8951 23.7459 10.7958 23.6848 10.7146 23.5505C10.6313 23.4127 10.7049 22.9822 10.852 22.1212C11.8074 16.5305 15.6549 15.0355 18.4123 15.0355V12.6232C18.4123 12.1347 18.4123 11.8904 18.511 11.7707C18.5967 11.6666 18.7261 11.6085 18.8608 11.6136C19.0159 11.6194 19.1984 11.7817 19.5636 12.1062Z",
    fill: "#28475C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EBF0F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.3ec64d2907d15fd721e1126e8f3e4be1.svg";
export { ForwardRef as ReactComponent };